import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { Pages } from "../../utils";

function ContactCTA() {
  return (
    <Box
      sx={{
        marginTop: "108px",
        width: "100%",
        "@media (max-width: 991px)": {
          maxWidth: "100%",
          marginTop: "40px",
        },
      }}
    >
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#D22268",
          display: "flex",
          width: "100%",
          paddingTop: "64px",
          paddingBottom: "64px",
          flexDirection: "column",
          fontFamily: "Jost, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: "26px",
          color: "#FFF",
          textAlign: "center",
          paddingLeft: "64px",
          paddingRight: "64px",
          "@media (max-width: 991px)": {
            maxWidth: "100%",
          },
          "@media (max-width: 640px)": {
            paddingLeft: "32px",
            paddingRight: "32px",
          },
        }}
      >
        <Box
          sx={{
            alignSelf: "stretch",
            fontSize: "29px",
            fontWeight: "700",
            lineHeight: "1",
            "@media (max-width: 991px)": {
              maxWidth: "100%",
            },
          }}
        >
          <Typography variant="h4" className="font-size-5">
            Start Fueling Your Future with Home Design Guild
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: "600px",
            fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
            fontWeight: "400",
            lineHeight: "32px",
            marginTop: "20px",
            width: "600px",
            "@media (max-width: 991px)": {
              maxWidth: "100%",
            },
          }}
        >
          <Typography variant="body2" className="margin-0 font-size-3">
            Join Home Design Guild and experience the difference a
            designer-first platform can make.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            marginTop: "20px",
            width: "178px",
            maxWidth: "100%",
            paddingTop: "12px",
            alignItems: "end",
            gap: "40px",
            color: "#D22268",
            fontWeight: "600",
            lineHeight: "1",
            justifyContent: "center",
          }}
        >
          <Button
            component={Link}
            to={Pages.SIGNUP}
            variant="contained"
            color={"white" as any}
            size="large"
            className="font-size-3"
          >
            Apply Now
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ContactCTA;
